module.exports = __webpack_public_path__ + "static/mc-mockup-a05673be617554162bfd12d5b3503737.png";